import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productAttributesStyles } from "@insite/content-library/Components/ProductAttributes";
import { css } from "styled-components";

productAttributesStyles.attributeValueGridItem = mergeToNew(productAttributesStyles.attributeValueGridItem, {
    css: css`
        overflow: hidden;
        [class^="TypographyStyle"] {
            font-size: 14px;
        }
    `,
});

productAttributesStyles.attributeTypeText = mergeToNew(productAttributesStyles.attributeTypeText, {
    weight: "bold",
    color: "text.accent",
    size: 14,
});
